export const NameSpacing: (nameSpace: string, fieldName: string | number) => string = (
    nameSpace: string,
    fieldName: string | number
) => `${nameSpace}.${fieldName}`
